  <template>
  <v-toolbar color="white" dark elevation="2">
    <v-toolbar-title>
      <v-img
        alt="Dutch Bros"
        class="shrink mr-2"
        contain
        src="https://files.dutchbros.com/logos/primary_logo_blue_text.png"
        transition="scale-transition"
        width="150"
      />
    </v-toolbar-title>
    <v-spacer />
  </v-toolbar>
</template>


<script>
export default {
  name: "TitleBarHome",
};
</script>